import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

private readonly notificationState = new BehaviorSubject<{ notificationMessage: string, isOpen: boolean, notificationType: any }>({
  notificationMessage:'',
  isOpen: false,
  notificationType: ''
  });

  notificationState$ = this.notificationState.asObservable();

  showNotification( notificationMessage: string, notificationType: any) {
    this.notificationState.next({ notificationMessage: notificationMessage,  isOpen: true, notificationType: notificationType});
  }

  closeNotification() {
    this.notificationState.next({ notificationMessage: '',  isOpen: false, notificationType: ''});
  }
}

export enum ToastType {
  Success,
  Warning,
  Error,
  Highlight
}

